import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'shared-x-of-counter',
    templateUrl: './x-of-counter.shared.component.html',
    styleUrls: ['./x-of-counter.shared.component.scss']
})
export class XOfCounterComponent implements OnInit {
    @Input() public current: number;
    @Input() public of: number;
    @Input() public separator: string = '/';

    constructor() { }

    ngOnInit(): void { }
}
